<template>
    <v-menu
        ref="dateRangeMenu"
        v-model="dateRangeMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="modelDisplay"
                label="Date Range"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                persistent-hint
                :hint="hint"
            >
            </v-text-field>
        </template>
        <v-card>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="6">
                        <v-text-field
                            v-model="dateRange[0]"
                            type="date"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            dense
                            persistent-hint
                            hint="Input the start date: MM/DD/YYYY"
                        >
                        </v-text-field>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field
                            v-model="dateRange[1]"
                            label="End Date"
                            type="date"
                            prepend-icon="mdi-calendar"
                            dense
                            persistent-hint
                            hint="Input the end date: MM/DD/YYYY"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-date-picker
                            v-model="dateRange"
                            :label="label"
                            :hint="hint"
                            :color="color"
                            range
                            scrollable
                            :min="min"
                            :max="max"
                            width="30vw"
                        >
                        </v-date-picker>
                    </v-col>
                </v-row>
                <slot></slot>
            </v-card-text>
        </v-card>
        <!--Manual input-->
    </v-menu>
</template>

<script>
export default {
    name: 'DateRangeMenu',
    props: {
        label: {
            type: String,
            default: 'Date'
        },
        hint: {
            type: String,
            default: 'Select a date'
        },
        color: {
            type: String,
            default: 'info'
        },
        min: {
            type: String,
            // Default to 5 years ago in YYYY-MM-DD format
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() - 5)
            )
                .toISOString()
                .split('T')[0]
        },
        max: {
            type: String,
            // Default to 5 years from now in YYYY-MM-DD format
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() + 5)
            )
                .toISOString()
                .split('T')[0]
        }
    },
    data() {
        return {
            dateRangeMenu: false,
            modelDisplay: 'Select a date range',
            dateRange: []
        };
    },
    methods: {
        setDateRange() {
            let dateRange = this.dateRange;
            this.dateRangeStart = '';
            this.dateRangeEnd = '';
            //If the end date is less than the start date, swap them
            if (dateRange[1] < dateRange[0]) {
                let temp = dateRange[0];
                dateRange[0] = dateRange[1];
                dateRange[1] = temp;
            }
            this.dateRangeStart = dateRange[0];
            this.dateRangeEnd = dateRange[1];
            this.modelDisplay = `${this.dateRangeStart} ~ ${this.dateRangeEnd ??
                'Pending selection'}`;
        }
    },
    watch: {
        dateRange() {
            this.$emit('update:dateRange', this.dateRange);
            this.setDateRange();
            if (this.dateRange.length === 2) {
            }
        }
    }
};
</script>
